import { FetchStreetTypesRequest } from './../../street-types/street-types.actions'
import { getStreetTypesState } from './../../street-types/street-types.selectors'
import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  CreateStreetRequest,
  SetDefaultData,
} from './../streets.actions'
import { getCreateStreetState } from './../streets.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-street',
  templateUrl: './create-street.component.html',
  styleUrls: ['./create-street.component.css'],
})
export class CreateStreetComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public streetTypes: any[]
  private state$: Subscription
  private streetTypesState$: Subscription
  public isLoading: boolean
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createStreet'))

    this.streetTypesState$ = this.store
      .pipe(select(getStreetTypesState))
      .subscribe((streetTypes) => {
        this.streetTypes = streetTypes.get('data').toJS()
      })

    this.state$ = this.store
      .pipe(select(getCreateStreetState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch<any>(new FetchStreetTypesRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.streetTypesState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createStreet.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createStreet',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      // streetTypeId: "required",
    }
    const validator = new Validator(
      {
        name: data.get('name'),
        streetTypeId: data.get('streetTypeId'),
      },
      rules,
    )

    validator.setAttributeNames({
      streetTypeId: 'street type',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateStreetRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createStreet',
        ),
      )
    }
  }
}
